import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IWidgetItem } from '../../interfaces/widget-item.interface';
import { Widget } from '../../decorator/widget.decorator';
import { IdynamicFormItem } from '../../../../app/shared/dynamic-form/interfaces/IdynamicFormItem';

@Component({
  selector: 'ispm-placeholder-widget',
  templateUrl: './placeholder-widget.component.html',
  styleUrls: ['./placeholder-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('placeholder')
export class PlaceholderWidgetComponent implements OnInit, IWidgetItem {
  public title: string = 'Placeholder';
  public placeholderHeight: string = '30';

  constructor() {
  }

  ngOnInit() {
  }

  set widgetConfig(widgetConfig: IdynamicFormItem) {
    this.title = widgetConfig.label;
    if (widgetConfig.widgetPayload && widgetConfig.widgetPayload.height){
      this.placeholderHeight = widgetConfig.widgetPayload.height;
    }
  }

  set widgetData(widgetData: any) {
  }
}
